import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import { push } from "react-router-redux";

import {
  PASSWORD_RESET_REQUEST,
  passwordResetSuccess,
  passwordResetError,
} from "./actions";
import { Env } from "../../env";

function* passwordResetRequest(action) {
  const { password, passwordCheck, accessToken } = action;
  var at = accessToken.replace("?", "");

  if (password !== passwordCheck) {
    yield put(passwordResetError("Les mots de passe ne correspondent pas."));

    return;
  }

  try {
    yield call(
      axios.post,
      `${Env.BASE_API_URL}/Accounts/reset-password`,
      {
        newPassword: password,
      },
      {
        headers: { Authorization: at },
      }
    );
  } catch (err) {
    let error;
    if (err.response && err.response.status === 401) {
      error = "Lien expiré, veuillez renouveler la demande.";
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
    }

    yield put(passwordResetError());
    yield put(flashMessage(error));

    return;
  }

  yield put(passwordResetSuccess());
  yield put(push("/login"));
  yield put(flashMessage("Mot de passe réinitialisé avec succès."));
}

export default function* watchPasswordResetRequest() {
  yield takeLatest(PASSWORD_RESET_REQUEST, passwordResetRequest);
}



// WEBPACK FOOTER //
// ./src/pages/password-reset/saga.js